/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable no-empty-function */
/* eslint-disable flowtype/no-types-missing-file-annotation */
import moment from 'moment-timezone';
import React, { FC, useContext, useState } from 'react';
import { useSelector } from 'react-redux';

import { callService2, meetService } from '../../../../../../service';
import { STATUS } from '../../../../../../socket/config';
import { SocketContext } from '../../../../../../socket/socket.context';
import { goToRoomWithToken } from '../../../../../../utils';
import { ModalSelectGroupCall } from '../ModalSelectGroupCall';

import { EditContact } from './EditContact';
import { EditGroup } from './EditGroup';

// import InvitePopup from './InvitePopup';

export interface PhoneBookContactItemProps {
    item: PhoneBookData;
    index: number;
    onSelectUser: () => void;
}

const PhoneBookContactItem: FC<PhoneBookContactItemProps> = props => {
    const { item, index, onSelectUser, selectedUserList, addContactList }
        = props;
    const [ openModalCall, setOpenModalCall ] = useState(false);
    const { usersStatus, sendUserStatus } = useContext(SocketContext);
    const { user } = useSelector(state => state['features/settings']);
    const [ typeCall, setTypeCall ] = useState({});
    const [ openEdit, setOpenEdit ] = useState(false);
    const [ openEditGroup, setOpenEditGroup ] = useState(false);
    const { room, conference } = useSelector(
        state => state['features/base/conference']
    );
    const defaultAvatarUser
        = 'https://dev.pantherconnect.me/images/gen-avatar.jpg';
    const status = usersStatus ? usersStatus[item?.id] : undefined;

    // const [ openInvitePopUp, setOpenInvitePopUp ] = useState(false);
    // const [ positionPopup, setPositionPopup ] = useState({ top: 0,
    //     left: 0 });

    let color = 'green';

    switch (status) {
    case STATUS.ONLINE: {
        color = 'green';
        break;
    }
    case STATUS.OFFLINE: {
        color = 'gray';
        break;
    }
    case STATUS.BUSY: {
        color = 'red';
        break;
    }
    case STATUS.DND: {
        color = 'yellow';
        break;
    }
    case undefined: {
        color = 'gray';
        break;
    }
    }

    const callToPhone = async number => {
        if (conference) {
            await callService2
                .addUserFromNumberIntoCall(room, number)
                .then(async res => {
                    const phoneNumber
                        = res.data?.callingHistory?.receivers.slice(-1)[0]
                            .phoneNumber;

                    await conference.dial(`${phoneNumber}`);
                });
        } else {
            await callService2
                .createUserCallByPhone(number)
                .then(async res => {
                    const phoneNumber
                        = res.data?.callingHistory?.receivers[0].phoneNumber;

                    sessionStorage.setItem(
                        `room=${res.data?.callingHistory?.id}`,
                        phoneNumber
                    );
                    const meeting = await meetService.createMeeting(
                        res?.data?.callingHistory?.id,
                        `${user.firstName} ${user.lastName}`,
                        user.email,
                        user.id
                    );
                    const meetingrest = await meetService.getMeetingData(
                        meeting?.data?.id
                    );

                    // goToPage(`home?room=${res.data?.callingHistory?.id}`);
                    goToRoomWithToken(meetingrest.authRoom, meetingrest.token);

                    sessionStorage.setItem(
                        `ringing-${res.data?.callingHistory?.id}`,
                        true
                    );
                    sessionStorage.setItem(
                        `ringing-${res.data?.callingHistory?.id}-firstName`,
                        item.firstName
                    );
                });
        }
    };

    const handleCall = async (sendEmail = false) => {
        if (!user.id && !item.id) {
            return;
        }
        const timeZone = moment.tz.guess();

        if (item.isGroup) {
            if (room) {
                await callService2.addGroupCall(room, item.id, timeZone);
            } else {
                setOpenModalCall(false);
                await callService2
                    .createGroupCall(item.id, { timeZone,
                        typeCall })
                    .then(async res => {
                        const meeting = await meetService.createMeeting(
                            res?.data?.callingHistory?.id,
                            `${user.firstName} ${user.lastName}`,
                            user.email,
                            user.id
                        );
                        const meetingrest = await meetService.getMeetingData(
                            meeting?.data?.id
                        );

                        sendUserStatus(user.id, STATUS.BUSY);

                        goToRoomWithToken(
                            meetingrest.authRoom,
                            meetingrest.token
                        );
                        let ringTone = false;

                        item.contacts.forEach(async contact => {
                            if (typeCall[contact._id] === 'phone') {
                                const phoneNumber = contact.phoneNumber;

                                callToPhone(phoneNumber);
                                // await conference.dial(`${phoneNumber}`);
                            }
                            if (contact.permissionLevel !== 2) {
                                ringTone = true;
                            }
                        });
                        if (ringTone) {
                            sessionStorage.setItem(
                                `ringing-${res.data?.callingHistory?.id}`,
                                true
                            );
                            sessionStorage.setItem(
                                `ringing-${res.data?.callingHistory?.id}-firstName`,
                                item.name
                            );
                        }
                    });
            }
        } else if (room) {
            // v2

            let shouldSendEmail = sendEmail;

            if (item.permissionLevel === 2) {
                shouldSendEmail = true;
            }

            if (
                !status
                || status === STATUS.OFFLINE
                || status === STATUS.BUSY
            ) {
                if (item.email) {
                    shouldSendEmail = true;
                } else if (item.phoneNumber) {
                    callToPhone(item.phoneNumber);

                    return;
                }
            }

            await callService2.addUserFromContactIntoCall(
                room,
                item.id,
                shouldSendEmail,
                timeZone
            );
        } else {
            // v2
            let shouldSendEmail = sendEmail;

            if (item.permissionLevel === 2) {
                shouldSendEmail = true;
            }

            if (
                !status
                || status === STATUS.OFFLINE
                || status === STATUS.BUSY
            ) {
                if (item.email) {
                    shouldSendEmail = true;
                } else if (item.phoneNumber) {
                    callToPhone(item.phoneNumber);

                    return;
                }
            }
            await callService2
                .createUserCall(item.id, shouldSendEmail, timeZone)
                .then(async res => {
                    const meeting = await meetService.createMeeting(
                        res?.data?.callingHistory?.id,
                        `${user.firstName} ${user.lastName}`,
                        user.email,
                        user.id
                    );

                    const meetingrest = await meetService.getMeetingData(
                        meeting?.data?.id
                    );

                    sendUserStatus(user.id, STATUS.BUSY);
                    goToRoomWithToken(meetingrest.authRoom, meetingrest.token);
                    if (!shouldSendEmail) {
                        sessionStorage.setItem(
                            `ringing-${res.data?.callingHistory?.id}`,
                            true
                        );
                        sessionStorage.setItem(
                            `ringing-${res.data?.callingHistory?.id}-firstName`,
                            item.firstName
                        );
                    }
                });
        }
    };

    const getGroupUsers = itemUser => {
        let names = '';

        itemUser.contacts.length
            && itemUser.contacts.forEach((contact, i) => {
                if (i === 0) {
                    names = `${contact.firstName} ${contact.lastName}`;
                }
            });
        if (itemUser.contacts.length > 1) {
            names = `${names}, and ${itemUser.contacts.length - 1} more...`;
        }

        return names;
    };

    const onCall = () => {
        if (!item.isGroup) {
            return;
        }
        setOpenModalCall(true);
    };

    const onSetCall = (id, type) => {
        setTypeCall({
            ...typeCall,
            [id]: type
        });
    };

    const onEdit = event => {
        event.preventDefault();
        event.stopPropagation();
        if (!item.isGroup) {
            setOpenEdit(true);

            return;
        }
        setOpenEditGroup(true);
    };

    return (
        <>
            {item?.isGroup && (
                <ModalSelectGroupCall
                    onClose = { () => {
                        setOpenModalCall(false);
                        setTypeCall({});
                    } }
                    open = { openModalCall }>
                    <div className = 'o-create-group-title'>
                        <p>{item?.name}</p>
                    </div>
                    <div
                        style = {{
                            maxHeight: 400,
                            overflow: 'auto'
                        }}>
                        {item?.contacts?.map(contact => (
                            <div
                                className = 'list-group-item-action-call'
                                key = { contact.id }>
                                <div className = 'list-group-item-action-call--title'>
                                    {`${contact.firstName} ${contact.lastName}`.trim()}
                                </div>
                                <div className = 'list-group-action-call dis-flex'>
                                    <div
                                        className = {
                                            typeCall[contact.id] === ''
                                                ? 'list-group-item-action-call--item-active'
                                                : ''
                                        }
                                        onClick = { () =>
                                            onSetCall(contact.id, '')
                                        }>
                                        Video Call
                                    </div>
                                    <div
                                        className = {
                                            typeCall[contact.id] === 'phone'
                                                ? 'list-group-item-action-call--item-active'
                                                : ''
                                        }
                                        onClick = { () =>
                                            onSetCall(contact.id, 'phone')
                                        }>
                                        Phone Call
                                    </div>
                                    <div
                                        className = {
                                            typeCall[contact.id] === 'email'
                                                ? 'list-group-item-action-call--item-active'
                                                : ''
                                        }
                                        onClick = { () =>
                                            onSetCall(contact.id, 'email')
                                        }>
                                        Invite by Email
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className = 'footer-modal-call-group'>
                        <div
                            className = 'footer-modal-call-group--button'
                            onClick = { handleCall }
                            style = {{ cursor: 'pointer' }}>
                            Start Call
                        </div>
                    </div>
                </ModalSelectGroupCall>
            )}
            {!item.isGroup && (
                <EditContact
                    onClose = { () => setOpenEdit(false) }
                    open = { openEdit }
                    user = { item } />
            )}
            {item.isGroup && (
                <EditGroup
                    addContactList = { addContactList }
                    group = { item }
                    onClose = { () => setOpenEditGroup(false) }
                    open = { openEditGroup }
                    selectedUserList = { selectedUserList } />
            )}
            <div
                className = 'o-phone-book-item mr-10'
                key = { index }>
                <div
                    className = 'o-phone-book-item-user'
                    onClick = { onCall }
                    style = {{ cursor: 'pointer' }}>
                    <div className = { 'dis-flex ali-center flex-1' }>
                        <div className = 'o-phone-book-item-user--avt-with-status'>
                            {item.isGroup ? (
                                <div className = 'o-user-list-item-img o-user-list-item-group'>
                                    <img
                                        height = '19'
                                        src = '../../../images/group-call.svg'
                                        width = '22' />
                                </div>
                            ) : (
                                <img
                                    alt = 'image'
                                    className = 'o-phone-book-item-avt'
                                    height = '48'
                                    src = { item?.avatar ?? defaultAvatarUser }
                                    width = '48' />
                            )}
                            {!item.isGroup && item.permissionLevel !== 2 && (
                                <div
                                    className = { `o-phone-book-item-user--status o-phone-book-item-user--status--${color}` } />
                            )}
                            {(item.permissionLevel === 2 || item.isGroup)
                                && item.createdBy === user.id && (
                                <div
                                    className = 'icon-edit-phone-book'
                                    onClick = { onEdit }>
                                    <svg
                                        fill = '#ffffff'
                                        height = '12'
                                        id = 'pencil'
                                        viewBox = '0 0 512 512'
                                        width = '12'
                                        xmlns = 'http://www.w3.org/2000/svg'>
                                        <path
                                            d = 'M178.846 92.087h128.085v354.049H178.846z'
                                            transform = 'rotate(-134.999 242.89 269.113)' />
                                        <path d = 'M471.723 88.393l-48.115-48.114c-11.723-11.724-31.558-10.896-44.304 1.85l-45.202 45.203 90.569 90.568 45.202-45.202c12.743-12.746 13.572-32.582 1.85-44.305zM64.021 363.252L32 480l116.737-32.021z' />
                                    </svg>
                                </div>
                            )}
                        </div>
                        <div>
                            <div className = { 'dis-flex flex-column flex-1' }>
                                <b className = { 'o-phone-book-item-name' }>
                                    {item?.name}
                                </b>
                                {item.isGroup && (
                                    <p className = 'o-phone-book-item-names'>
                                        {getGroupUsers(item)}
                                    </p>
                                )}
                                <p className = { 'o-phone-book-item-sub-name' }>
                                    {item?.subName}
                                </p>
                            </div>
                            <div>
                                {!item.isGroup && (
                                    <div className = 'dis-flex mt-8'>
                                        {!(item.permissionLevel === 2 && item.createdBy === user.id) && (
                                            <div
                                                className = 'icon-video-call'
                                                onClick = { () => handleCall(false) }>
                                                <svg
                                                    fill = '#636365'
                                                    height = '24'
                                                    id = 'video-camera'
                                                    viewBox = '0 0 16 16'
                                                    width = '24'
                                                    xmlns = 'http://www.w3.org/2000/svg'>
                                                    <path d = 'M8.5,4 C9.32843,4 10,4.67157 10,5.5 L10,10.5 C10,11.3284 9.32843,12 8.5,12 L3.5,12 C2.67157,12 2,11.3284 2,10.5 L2,5.5 C2,4.67157 2.67157,4 3.5,4 L8.5,4 Z M13.2484,4.17778 C13.5560615,4.00182308 13.9331669,4.19321101 13.9895199,4.52565995 L13.9967,4.61158 L13.9996001,11.388 C13.9997846,11.7424615 13.6462746,11.9749065 13.3296592,11.8587365 L13.2515,11.8223 L11.0003,10.5359 L11.0003,5.46373 L13.2484,4.17778 Z' />
                                                </svg>
                                                <div className="button-label-popup">
                                                    Video Call
                                                </div>
                                            </div>
                                        )}
                                        {item.phoneNumber && (
                                            <div
                                                className = 'icon-video-call ml-10'
                                                onClick = { () =>
                                                    callToPhone(
                                                        item.phoneNumber
                                                    )
                                                }>
                                                <svg
                                                    fill = '#636365'
                                                    height = '15'
                                                    id = 'call'
                                                    width = '15'
                                                    xmlns = 'http://www.w3.org/2000/svg'>
                                                    <path d = 'M14.73 12.996c-.463 1.407-2.277 2.109-3.573 1.992-1.77-.16-3.696-1.099-5.158-2.133C3.85 11.335 1.837 8.984.664 6.489-.165 4.726-.351 2.558.882.951c.456-.594.95-.911 1.69-.948C3.6-.047 3.744.541 4.097 1.457c.263.685.614 1.384.81 2.094.367 1.325-.916 1.38-1.078 2.463-.1.683.727 1.599 1.101 2.086a10.105 10.105 0 0 0 2.608 2.403c.57.359 1.488 1.006 2.14.649 1.004-.55.91-2.243 2.313-1.67.727.296 1.431.723 2.125 1.097 1.073.577 1.023 1.175.614 2.417-.306.928.306-.928 0 0' />
                                                </svg>
                                                <div className="button-label-popup">
                                                    Phone Call
                                                </div>
                                            </div>
                                        )}
                                        {item.email && (
                                            <div
                                                className = 'icon-video-call ml-10'
                                                onClick = { () => handleCall(true) }>
                                                <svg
                                                    fill = '#636365'
                                                    id = 'mail'
                                                    version = '1.1'
                                                    viewBox = '0 0 29 29'
                                                    x = '0'
                                                    xmlSpace = 'preserve'
                                                    xmlns = 'http://www.w3.org/2000/svg'
                                                    y = '0'>
                                                    <path d = 'M2 7.42v14.172l7.086-7.086zM3.408 6l8.971 8.971c1.133 1.133 3.109 1.133 4.242 0L25.592 6H3.408z' />
                                                    <path d = 'M18.035 16.385c-.943.944-2.199 1.465-3.535 1.465s-2.592-.521-3.535-1.465l-.465-.465L3.42 23h22.16l-7.08-7.08-.465.465zM19.914 14.506L27 21.592V7.42z' />
                                                </svg>
                                                <div className="button-label-popup">
                                                    Invite by Email
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    className = 'o-phone-book-item-btn'
                    onClick = { () => onSelectUser(item?.id, index) }>
                    {item?.isContact
                        ? <div className = 'o-phone-book-item-dot' />
                        : null}
                </button>
            </div>
        </>
    );
};

PhoneBookContactItem.defaultProps = {};

export default PhoneBookContactItem;
